// extracted by mini-css-extract-plugin
export default {"verify_modal_wrapper":"forgetPassword_verify_modal_wrapper__C-L-X","heading":"forgetPassword_heading__OoQ9c","submit_btn":"forgetPassword_submit_btn__3UTpg"};